import React from 'react';
import StickySidebar from 'components/shared/StickySidebar';
import { useSelector } from 'react-redux';
import moment from 'moment';
import DateFormat from 'constants/date_format';

const InformationSidebar = () => {
  const { created_at, updated_at } = useSelector(state => {
    return state;
  });

  const formattedCreatedDate = moment(created_at).format(
    DateFormat.LONG_AT_TIME,
  );
  const formattedUpdatedDate = moment(updated_at).format(
    DateFormat.LONG_AT_TIME,
  );

  return (
    <StickySidebar className="JourneyBuilderInformationSidebar">
      <div className="JourneyBuilderInformationSidebarCard">
        <div className="JourneyBuilderInformationSidebarCard-header">
          <p>{t('journeys.builder.details')}</p>
        </div>
        <div className="JourneyBuilderInformationSidebarCard-created">
          <p className="JourneyBuilderInformationSidebarCard-info-title">
            {t('journeys.builder.created')}
          </p>
          <p className="JourneyBuilderInformationSidebarCard-info">
            {formattedCreatedDate}
          </p>
          <p className="JourneyBuilderInformationSidebarCard-info-title">
            {t('journeys.builder.last_updated')}
          </p>
          <p className="JourneyBuilderInformationSidebarCard-info">
            {formattedUpdatedDate}
          </p>
        </div>
      </div>
    </StickySidebar>
  );
};

export default InformationSidebar;
